import sensors from 'sa-sdk-javascript';

sensors.init({
  server_url: SENSORS_URL,
  heatmap: { clickmap: 'default', scroll_notice_map: 'not_collect' },
  is_track_single_page: true,
  use_client_time: true,
  show_log: false,
  send_type: 'beacon',
});

sensors.quick('autoTrack');

sensors.registerPage({
  platform_type: 'H5',
  line: '帕加马',
  product_line: ['PT'],
});
